import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-290" data-mp="vytjhye9w2gi">
      <h2 id={id} className="mx-auto max-w-3xl text-balance font-display text-4xl font-bold leading-[1.05] text-lava sm:text-5xl" data-id="element-291" data-mp="w1fts5sjsw2f">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-292" data-mp="n097th74qt1s">
        <span className="h-1 w-10 rounded-full bg-lava" data-id="element-293" data-mp="i76f1ba6fnmn" />
        <span className="h-1 w-3 rounded-full bg-energy" data-id="element-294" data-mp="d8lo62gtegav" />
      </span>
    </div>;
}